import { Box, HStack, Text, Icon, useDisclosure } from '@chakra-ui/react';
import { useEffect } from 'react';
import { IoTimeOutline } from 'react-icons/io5';

import ContentContainer from '~/containers/Content';

import LocationBar from '~/components/LocationBar';

import useScroll from '~/hooks/useScroll';

import pickMealAtAtom from '~/recoil/atom/pickMealAt';
import pickMealEndAtom from '~/recoil/atom/pickMealEnd';
import { useRecoilValue } from 'recoil';

import transformDateRangeToString from '~/utils/transformDateRangeToString';

export default function FixedHeaderSection() {
  const { positionInfo } = useScroll();
  const {
    isOpen: isSectionDisplay,
    onOpen: onSectionOpen,
    onClose: onSectionClose,
  } = useDisclosure({ isOpen: positionInfo.scrollTop >= 400 });
  const pickMealAt = useRecoilValue(pickMealAtAtom);
  const pickMealEnd = useRecoilValue(pickMealEndAtom);

  useEffect(() => {
    if (positionInfo.scrollTop > 400) {
      onSectionOpen();
    } else {
      onSectionClose();
    }
  }, [positionInfo]);

  const handleGoTop = () => {
    window.scrollTo({
      top: 0,
    });
  };

  return (
    <Box
      pos="fixed"
      top={0}
      w="full"
      zIndex={100}
      transition="0.3s"
      transform={`translateY(${isSectionDisplay ? '0' : '-100%'})`}
      onClick={handleGoTop}
      _hover={{
        cursor: 'pointer',
      }}
      bg="white"
      borderBottomColor="primary"
      borderBottomWidth="1px"
    >
      <LocationBar />
      <Box>
        <ContentContainer>
          <HStack px={4} py={2} borderBottomColor="primary" borderBottomWidth="1px">
            <Icon as={IoTimeOutline} color="primary" boxSize="1.5rem" />
            <Text flex="1" fontWeight="bold">
              {transformDateRangeToString(pickMealAt, pickMealEnd) || '未選擇時間'}
            </Text>
          </HStack>
        </ContentContainer>
      </Box>
    </Box>
  );
}
